import { ExtDomainsRepository, ExtGroupsRepository, GroupsRepository, RulesRepository } from '../repositories/rbac';
import { BaseEntitiesService } from './BaseEntitiesService';
import { createObjectsCache, createSingleton } from '../singleton';
export class GroupsService extends BaseEntitiesService {
    constructor() {
        super(new GroupsRepository());
    }
    static getInstance = createSingleton(() => new GroupsService(), '__rbac__groups');
}
export class ExtGroupsService extends BaseEntitiesService {
    constructor() {
        super(new ExtGroupsRepository());
    }
    static getInstance = createSingleton(() => new ExtGroupsService(), '__rbac__ext_groups');
}
export class ExtDomainsService extends BaseEntitiesService {
    constructor() {
        super(new ExtDomainsRepository());
    }
    static getInstance = createSingleton(() => new ExtDomainsService(), '__rbac__ext_domains');
}
export class RulesService extends BaseEntitiesService {
    domain;
    group;
    constructor(domain, group) {
        super(new RulesRepository(domain, group));
        this.domain = domain;
        this.group = group;
    }
    _dispose() {
        RulesService._cache.remove(this.domain, this.group);
        super._dispose();
    }
    static _cache = createObjectsCache((domain, group) => new RulesService(domain, group), '__rbac__rules');
    static createInstance = RulesService._cache.get;
}
